<template>

    <v-layout row  mb-3 class="issue-line">

        <v-flex xs2 md1 class="id-block" > 
            <v-layout column>

                <v-flex>
                    <v-btn @click="viewDetail(issue)" color="warning">{{ issue.issueID }}</v-btn>
                </v-flex>
                <v-flex class="days-ago">
                      <time-ago :datetime="issue.creationDate" refresh :locale="locale" :tooltip="true" :long="longString"></time-ago>
                        ago
                </v-flex>

            </v-layout>
        </v-flex>
        <v-flex xs7 md7 class="info-block">
            <v-layout column>
                <v-flex>
                    <v-layout row>
                        <v-flex class="text-bold">
                            {{ issue.issue }}
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex>
                    <v-layout row>
                        <v-flex class="text-medium">
                            {{ issue.issueType }}
                        </v-flex>
                        <v-flex class="text-medium" ml-2>
                            {{ issue.issueSubtype }}
                        </v-flex>

                        <v-flex class="text-medium" ml-2>
                            {{ issue.location }}
                        </v-flex>

                    </v-layout>
                </v-flex>

                <v-flex>
                    <v-layout row>
                        <v-flex shrink class="raised-by">R</v-flex>
                        <v-flex class="truncate text-small">
                            {{ issue.raisedBy }}
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex>
                    <v-layout row>
                        <v-flex shrink class="assigned-to">A</v-flex>
                        <v-flex  class="truncate text-small">
                            {{ issue.assignedTo }}
                        </v-flex>
                    </v-layout>
                </v-flex>

            </v-layout>
        </v-flex>
        <v-flex xs1 md1   >
            <v-layout column>
                <v-flex class="status" :class="[statusClass(issue.status)]">
                    {{ issue.status.toString().substring(0,1) }}
                </v-flex>
                <v-flex v-if="issue.status == 'Assigned' && new Date(issue.commitmentDate) > minDate" class="commitment-date">
                    {{ new Date(issue.commitmentDate) > minDate ? formatDate(issue.commitmentDate) : '' }}
                </v-flex>
                <v-flex v-else-if="issue.status == 'Closed'  && new Date(issue.closeDate) > minDate " class="close-date">
                    {{ new Date(issue.closeDate) > minDate ? formatDate(issue.closeDate) : '' }}
                </v-flex>

            </v-layout>
            
        </v-flex>

    </v-layout>

</template>
<script>
import TimeAgo from 'vue2-timeago'
import 'vue2-timeago/dist/vue2-timeago.css'

export default {
    components:{TimeAgo},
    props:['issue'],
    data(){
        return {
            minDate:new Date('1/1/2020')
        }
    },
    computed:{
    },
    methods:{
        statusClass(status){
           // console.log("status",`status-${status.toString().toLowerCase()}`)
           if (!status){
               status = "Open"
           }
            return   `status-${status.toString().toLowerCase()}`;
        },
        viewDetail(issue){
            //console.log("issue",issue)
            this.$emit('clickIssue',issue)
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate();
                //year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [month, day].join('-');
        }
    },
    mounted(){
        //console.log(this.issue)
        //console.log(this.issue.status.toString().substring(0,1))
        this.statusClass();
    }
}
</script>
<style scoped>
.id-block{
    min-width: 80px;
    max-width: 80px;
}
.info-block{
    padding-left: 5px;
    min-width: 180px;
}
.status{
    font-size: 30px;
    background-color: cadetblue;
    color: white;
    text-align: center;
    padding-top: 8px;
    margin-top: 0px;
    margin-bottom: 5px;
    min-width: 60px;
    min-height: 60px;
    max-width: 60px;
    max-height: 60px;
    border-radius: 30px;
}
.issue-line{
    padding-top: 8px;
    padding-left: 3px;
    list-style-type: none;
    background: white;
    border-radius: 10px;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.1);

}
.raised-by{
    background-color:green;
    border-radius: 10px;
    height: 20px;
    width: 20px;
    color: white;
    padding-left: 4px;

}
.assigned-to{
    background-color:red;
    border-radius: 10px;
    height: 20px;
    width: 20px;
    color: white;
    padding-left: 4px;
}
.truncate {
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-small{
    padding-left: 3px;
    font-size: 0.75rem;
}
.text-medium{
    font-size: 0.85rem;
    font-style: italic;
}
.text-bold{
    font-weight: bold;
    font-size: 1.1rem;
}
.days-ago{
    margin-top: 20px;
    margin-left: 10px;
    font-size: 0.85rem;
}
.status-open{
    background-color: red;
}
.status-assigned{
    background-color:lightblue;
}
.status-closed{
    background-color: yellowgreen;
}
.status-verified-close{
    background-color: green;
}   
.commitment-date{
    background-color:blue;
    color:white;
    font-size: 0.8rem;
    padding: 5px;
    min-width: 50px;
    border-radius: 3px;
    margin-left: 5px;
    margin-bottom: 5px;
    text-align: center;
}
.close-date{
    background-color: green;
    color:white;
    font-size: 0.8rem;
    padding: 5px;
    min-width: 50px;
    border-radius: 3px;
    margin-left: 5px;
    margin-bottom: 5px;
    text-align: center;
}
</style>